/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-param-reassign */
import CustomModal from 'custom-components/customModal';
import { Box, Typography, Button } from '@material-ui/core';
import React, { useState } from 'react';
import { useStyles } from './recentDesignStyle';
import InputField from 'custom-components/form-fields/inputField';
import {
    API,
    POSTAPIWITHCUSTOMDOMAIN
} from 'api-setup/api-helper';
import { useHistory } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import ProjectSetting from 'settings';
import { setNewMessage } from 'redux/actions/setting-actions';
import { commonSelector, basicInfoSelector } from 'redux/custom-selector';
import { useSource } from 'lib/custom-common-hooks';
import { getUserCredential } from 'lib/cookies';


export default function CreateNewDLPModal({ open, onClose, currentTemplate }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const source = useSource();
  const reduxData = useSelector(commonSelector, shallowEqual);
  const [name, setName] = useState('');
  const cookiesData = getUserCredential();
  const [headers] = API.generateHeader(reduxData, null, null);
  const basicInfo = useSelector(basicInfoSelector, shallowEqual);
  const [error, setError] = useState('');

  const APICALL = React.useCallback(
    (ACTION, reduxData, methodType, URL, headerData, bodyData, APICB) => {
      const [header, body] = API.generateHeader(reduxData, headerData, bodyData);
      let APIPromise;
      const customUrl = ProjectSetting.customBaseURL2;
      if (methodType === 'POST') {
        APIPromise = POSTAPIWITHCUSTOMDOMAIN(false, URL, source.AS, header, body, customUrl);
      }

      APIPromise.then((resp) => {
        if (resp.data.status === API.apiSuccessStatus) {
          if (resp.data.message)
            dispatch(setNewMessage({ message: resp.data.message, type: 'success', show: true }));
          if (APICB) APICB(ACTION, 'SUCCESS', resp.data, body);
        } else {
          API.errStatusHandler(resp, history, dispatch, () => {
            if (APICB) APICB(ACTION, 'ERROR', resp.data);
          });
        }
      }).catch((error) => {
        dispatch(setNewMessage({ message: error?.response?.data?.message, type: 'error', show: true }));
        setError(error?.response?.data?.message);
      });
    },
    []
  );

  const handleChange = (event) => {
    // if (event.target.value === '') {
    //     setError(true);
    //     setName('');
    // } else {
    //     setError(false);
    setError('');
    setName(event.target.value);
    // }
  };

  const createLP = (isSkip = false) => {
    APICALL(
      'CREATE_LANDINGPAGE',
      reduxData,
      'POST',
      '/landing-page/dlp',
      null,
      {
        ...(isSkip ? {} : { name }),
        template: currentTemplate.template,
      },
      (ACTION, type, data) => {
        if (type === 'SUCCESS') {
          const url = `${process.env.REACT_APP_BUILDER_URL}/validate-token?token=${cookiesData.authToken}&eventId=${headers.eventId}&currentLPID=${data?.data?._id}&organiserId=${headers.organiserId}${basicInfo?.selectedLanguages?.[0] ? `&language=${basicInfo?.selectedLanguages?.[0]}` : ''}${headers.teamMemberId ? `&teamMemberId=${headers.teamMemberId}` : ''}${type === 'preview' ? `&route=preview/${data?.data?._id}` : ''}`;
          window.open(url, '_blank');
          if (data) {
            setName('');
            onClose();
            setError('');
          }
        }
      }
    );
  };

  return (
    <CustomModal isOpen={open} onClose={() => {
      if (onClose) {
        onClose();
      }
      setName('');
      setError('');
    }} paddingZero>
      <Typography variant="h5" className={classes.heading} component="h4">
        Let's Build Your site
      </Typography>
      <Box width={743} p={2.5} className={classes.modalWrapper} display="flex">
        <Box
          width="40%"
          position="relative"
          display="flex"
          flexDirection="column"
          justifyContent="space-between">
          <Box>
            <Typography component="label" className={classes.label} variant="body2">
              Landing Page Name
            </Typography>

            <InputField
              placeholder="Name your landing page"
              maxLength={50}
              name="LPName"
              value={name}
              error={error}
              // error={error ? "Please enter landing page name" : false}
              onChange={handleChange}
            />
          </Box>
          <Box mt={4} className={classes.modalAction} display="flex" alignItems="center">
            <Button
              onClick={() => createLP(false)}
              variant="contained"
              // disabled={name === ''}
              color="primary">
              Continue
            </Button>
            <Button variant="outlined" color="primary" onClick={() => createLP(true)}>
              Skip
            </Button>
          </Box>
        </Box>
        <Box width="60%">
          <Box className={classes.modalPreview}>
            <img
              src={`${process.env.REACT_APP_CDN_PATH}/newlp/images/${currentTemplate?.image}`}
              alt={`no-${currentTemplate?.template}`}
            />
          </Box>
        </Box>
      </Box>
    </CustomModal>
  );
}
